import { render, staticRenderFns } from "./QScoreCardDirectAgencyRegistrations.vue?vue&type=template&id=89e51dd2&scoped=true&"
import script from "./QScoreCardDirectAgencyRegistrations.vue?vue&type=script&lang=js&"
export * from "./QScoreCardDirectAgencyRegistrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e51dd2",
  null
  
)

export default component.exports